"use strict";

var _slicedToArray = require("/home/circleci/project/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useProvider = _interopRequireDefault(require("../../hooks/useProvider"));

var _useChat = _interopRequireDefault(require("../../hooks/useChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var styles = {
  appearance: 'none',
  background: 'none',
  borderRadius: '50%',
  bottom: '18pt',
  display: 'inline',
  height: '45pt',
  padding: '0px',
  position: 'fixed',
  right: '18pt',
  top: 'auto',
  width: '45pt',
  zIndex: 2147483647,
  // 1 more than the actual widget
  overflow: 'hidden',
  boxShadow: '0 3px 12px rgba(0, 0, 0, .15)',
  transition: 'box-shadow 150ms linear',
  cursor: 'pointer',
  outline: 'none',
  userSelect: 'none'
}; // eslint-disable-next-line react/display-name

var CustomerChat = /*#__PURE__*/(0, _react.memo)(function (_ref2) {
  var providerKey = _ref2.providerKey,
      color = _ref2.color,
      loggedInGreeting = _ref2.loggedInGreeting,
      loggedOutGreeting = _ref2.loggedOutGreeting,
      greetingDialogDisplay = _ref2.greetingDialogDisplay,
      greetingDialogDelay = _ref2.greetingDialogDelay;
  var fields = {
    page_id: providerKey,
    theme_color: color,
    logged_in_greeting: loggedInGreeting,
    logged_out_greeting: loggedOutGreeting,
    greeting_dialog_display: greetingDialogDisplay,
    greeting_dialog_delay: greetingDialogDelay
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fb-customerchat"
  }, fields));
});

var Widget = function Widget(_ref3) {
  var color = _ref3.color;

  var _ref4 = (0, _useChat.default)({
    loadWhenIdle: true
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      state = _ref5[0],
      loadChat = _ref5[1];

  if (state === 'complete') {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: styles,
    onClick: function onClick() {
      return loadChat({
        open: true
      });
    },
    onMouseEnter: function onMouseEnter() {
      return loadChat({
        open: false
      });
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    x: "0",
    y: "0",
    width: "60px",
    height: "60px"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    fill: color ? color : '#0084FF',
    cx: "30",
    cy: "30",
    r: "30"
  }), /*#__PURE__*/_react.default.createElement("svg", {
    x: "10",
    y: "10"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0.000000, -10.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "logo",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M20,0 C31.2666,0 40,8.2528 40,19.4 C40,30.5472 31.2666,38.8 20,38.8 C17.9763,38.8 16.0348,38.5327 14.2106,38.0311 C13.856,37.9335 13.4789,37.9612 13.1424,38.1098 L9.1727,39.8621 C8.1343,40.3205 6.9621,39.5819 6.9273,38.4474 L6.8184,34.8894 C6.805,34.4513 6.6078,34.0414 6.2811,33.7492 C2.3896,30.2691 0,25.2307 0,19.4 C0,8.2528 8.7334,0 20,0 Z M7.99009,25.07344 C7.42629,25.96794 8.52579,26.97594 9.36809,26.33674 L15.67879,21.54734 C16.10569,21.22334 16.69559,21.22164 17.12429,21.54314 L21.79709,25.04774 C23.19919,26.09944 25.20039,25.73014 26.13499,24.24744 L32.00999,14.92654 C32.57369,14.03204 31.47419,13.02404 30.63189,13.66324 L24.32119,18.45264 C23.89429,18.77664 23.30439,18.77834 22.87569,18.45674 L18.20299,14.95224 C16.80079,13.90064 14.79959,14.26984 13.86509,15.75264 L7.99009,25.07344 Z"
  })))))))));
};

var Messenger = function Messenger(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  var _ref6 = (0, _useProvider.default)(),
      providerKey = _ref6.providerKey;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CustomerChat, _extends({
    color: color,
    providerKey: providerKey
  }, props)), /*#__PURE__*/_react.default.createElement(Widget, {
    color: color
  }));
};

var _default = Messenger;
exports.default = _default;